import React from 'react'
import { Popup } from '../../../components/Popup'

function RevenueShareVideoPopup({ videoPopup, setVideoPopup}) {
  return (
    <>
      <Popup show={videoPopup} close={() => setVideoPopup(false)} className='revenue_share_video'>
        <div
          style={{
            width: '80vw',
            height: '80vh',
            margin: 'auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              position: 'absolute',
              color: '#464646',
              fontSize: '100px',
              top: '0',
              right: '0',
              zIndex: '2',
              cursor: 'pointer',
              lineHeight: '44px',
              margin: '40px',
            }}
            onClick={() => setVideoPopup(false)}
            onKeyDown={() => setVideoPopup(false)} 
            tabIndex="0" 
            role="button"
          >
            ˟
          </div>
          <video
            controls
            autoPlay
            preload="metadata"
            // onPlay={() => sendVideoPlayedEvent()}
            // onTimeUpdate={handleTimeUpdate}
            style={{
              maxWidth: '-webkit-fill-available',
              maxHeight: '-webkit-fill-available',
            }}
          >
            <source src='https://d2ps1cw166f1t3.cloudfront.net/70e93528ed997ee20940d9429384de4498ad8635.mp4' type="video/mp4" />
          </video>
        </div>
      </Popup>
    </>
  )
}

export default RevenueShareVideoPopup
